<!--
  @Description: 公司列表
  @Author: wang.y 
  @Date: 2022-02-17 
-->
<template>
  <div class="company-table">
    <Table :columns="list_columns" :data="data">
      <template slot-scope="{ row }" slot="name">
        <div class="comp-item">
          <div class="comp-logo" @click="goToDetail(row)">
            <img :src="row.logo_path | logo_show" />
          </div>
          <div class="comp-decs">
            <div class="p1 over-p1" @click="goToDetail(row)">{{row.short_name}}</div>
            <a :href="$store.state.index_path + '/companyDetail/' + row.entity_uid"></a>
            <div class="p2 over-p1">{{row.description}}</div>
          </div>
        </div>
      </template>
      <template slot-scope="{ row }" slot="decs">
        <div>{{row.event_time | timeTrans}}/{{row.round_id | deal('round')}}</div>
        <div>{{row.amount | amountPrecise(row.unit_id, row.precise)}}</div>
      </template>
      <template slot-scope="{ row }" slot="tzf">
        <div class="over-p2">
          <span v-for="t, t_index in row.tzf" :key="t_index">
            {{t_index == row.tzf.length -1 ? t.entity_name : t.entity_name+'、'}}
          </span></div>
      </template>
      <template slot-scope="{ row }" slot="action">
        <div class="comp-btn" @click="goToDetail(row)">详情</div>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  props: ['data', 'colType'],
  components: {},
  created() {},
  mounted() {},
  data() {
    return {
      list_columns: [{
        title: '项目',
        slot: 'name',
        width: 200
      }, {
        title: '时间/轮次/金额',
        slot: 'decs',
        width: 200
      }, {
        title: '投资方',
        slot: 'tzf'
      }, {
        title: ' ',
        slot: 'action',
        width: 100
      }],
      list_data: Array(4).fill({})
    }
  },
  computed: {
    static_img_url() {
      return this.$store.state.static_img_url
    },
  },
  methods: {
    //跳转至项目详情
    goToDetail(item) {
      const { href } = this.$router.resolve({ name: 'CompanyDetail', params: { uid: item.entity_uid } })
      window.open(href, '_blank')
      if(this.colType == '1') _czc.push(['_trackEvent', '找公司(新)', '早期项目发掘机(融资项目的公司)', '点击量'])
      if(this.colType == '2') _czc.push(['_trackEvent', '找公司(新)', '未来头条公司(融资项目的公司)', '点击量'])
      if(this.colType == '3') _czc.push(['_trackEvent', '找公司(新)', '活跃机构投资版图(活跃机构的机构)', '点击量'])
    }
  }
}
</script>
<style lang="stylus" scoped>
@import '~styles/common2.0.stylus'
</style>